import { z } from 'zod';
import { meetingBodyClerksSchema } from '../meeting-bodies/index.js';
export const jointMeetingBodyAgendaTemplateSchema = z.object({
    agendaTemplateId: z.number(),
    isDefault: z.boolean(),
});
export const jointMeetingBodyBaseSchema = z.object({
    name: z.string('Name is required').min(1, 'Name is required'),
    meetingBodiesIds: z.array(z.number()).min(2, 'At least two meeting bodies are required'),
    agendaTemplates: z.array(jointMeetingBodyAgendaTemplateSchema),
    clerks: meetingBodyClerksSchema.optional(),
    location: z.string().nullish(),
    locationId: z.number().nullish(),
    recurringInterval: z.string().nullish(),
    recurringDay: z.string().nullish(),
    virtualMeetingUrl: z.url('Must be a valid URL').nullable().optional(),
    meetingDialIn: z.string().nullable().optional(),
    meetingVirtualId: z.string().nullable().optional(),
    autoPublishMediaArchive: z.boolean().optional(),
    recurringTime: z
        .string()
        .nullish()
        .refine((time) => {
        if (!time)
            return true;
        const [hours, minutes] = time.split(':').map(Number);
        return (typeof hours === 'number' &&
            typeof minutes === 'number' &&
            hours >= 0 &&
            hours < 24 &&
            minutes >= 0 &&
            minutes < 60);
    }, {
        message: 'Invalid time format. Please use HH:MM format.',
    }),
    isActive: z.boolean(),
});
export const jointMeetingBodyUpdateSchema = jointMeetingBodyBaseSchema.partial();
